import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { guid } from "nav-frontend-js-utils";
import Alertstripe from "nav-frontend-alertstriper";
import { Undertittel, Ingress } from "nav-frontend-typografi";
import { SkjemaGruppe, Radio, RadioGruppe, Checkbox, CheckboxGruppe, Input, TextareaControlled } from "./../../";
export const _frontmatter = {
  "ingress": "Skjemagruppe lar deg semantisk gruppere flere skjemaelementer i en `fieldset`. Du kan både gi denne gruppen en felles overskrift (`legend`) og en felles feilmelding."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normalfieldset"
          }}>{`Normal/Fieldset`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#legend"
          }}>{`Legend`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#normal"
              }}>{`Normal`}</a></li><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#custom-styling"
              }}>{`Custom styling`}</a></li></ol></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#innhold-mellom-legend-og-skjemagruppe"
          }}>{`Innhold mellom legend og skjemagruppe`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#grupper-av-radio--og-checkboxer"
          }}>{`Grupper av radio- og checkboxer`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#radiogruppe"
              }}>{`RadioGruppe`}</a></li><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#checkboxgruppe"
              }}>{`CheckboxGruppe`}</a></li></ol></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#felles-feilmelding"
          }}>{`Felles feilmelding`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#uten-propagering-av-feil-prop-til-children"
              }}>{`Uten propagering av feil-prop til children`}</a></li></ol></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#custom-element"
          }}>{`Custom element`}</a></li></ol></nav>
    <h2 {...{
      "id": "normalfieldset"
    }}>{`Normal/Fieldset`}</h2>
    <p>{`I sin enkleste from er SkjemaGruppe bare en `}<inlineCode parentName="p">{`fieldset`}</inlineCode>{`-wrapper som sørger for semantisk gruppering av et sett med skjemafelter. Skjemaelementer i en SkjemaGruppe får som default `}<inlineCode parentName="p">{`1rem`}</inlineCode>{` vertikal avstand til hverandre.`}</p>
    <Example mdxType="Example">
  <SkjemaGruppe mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" mdxType="Input" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe>
  <Input label="Fornavn" />
  <Input label="Etternavn" />
</SkjemaGruppe>
`}</code></pre>
    <h2 {...{
      "id": "legend"
    }}>{`Legend`}</h2>
    <h3 {...{
      "id": "normal"
    }}>{`Normal`}</h3>
    <p>{`Du kan også gi skjemagruppen en felles overskrift (`}<inlineCode parentName="p">{`legend`}</inlineCode>{`):`}</p>
    <Example mdxType="Example">
  <SkjemaGruppe legend="Kontaktperson" mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" mdxType="Input" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe legend="Kontaktperson">
  <Input label="Fornavn" />
  <Input label="Etternavn" />
</SkjemaGruppe>
`}</code></pre>
    <h3 {...{
      "id": "custom-styling"
    }}>{`Custom styling`}</h3>
    <p>{`Du kan også sende inn en annen `}<a parentName="p" {...{
        "href": "/components/typografi"
      }}>{`Typografi-komponent`}</a>{` for å overstyre default `}<inlineCode parentName="p">{`legend`}</inlineCode>{`-styling.`}</p>
    <Example mdxType="Example">
  <SkjemaGruppe legend={<Undertittel mdxType="Undertittel">Kontaktperson</Undertittel>} mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" mdxType="Input" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe legend={<Undertittel>Kontaktperson</Undertittel>}>
  <Input label="Fornavn" />
  <Input label="Etternavn" />
</SkjemaGruppe>
`}</code></pre>
    <h2 {...{
      "id": "innhold-mellom-legend-og-skjemagruppe"
    }}>{`Innhold mellom legend og skjemagruppe`}</h2>
    <p>{`Bruk `}<inlineCode parentName="p">{`description`}</inlineCode>{`-propen for å legge inn egendefinert HTML-innhold mellom legend og skjemagruppen.`}</p>
    <Example mdxType="Example">
  <SkjemaGruppe legend="Kontaktperson" description="Personen som noen kan kontakte" mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" mdxType="Input" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe
  legend="Kontaktperson"
  description="Personen som noen kan kontakte"
>
  <Input label="Fornavn" />
  <Input label="Etternavn" />
</SkjemaGruppe>
`}</code></pre>
    <h2 {...{
      "id": "grupper-av-radio--og-checkboxer"
    }}>{`Grupper av radio- og checkboxer`}</h2>
    <p>{`Skjemagrupper brukes vanligvis for å gruppere flere radioknapper eller checkboxer. For slike grupper har vi laget egne `}<a parentName="p" {...{
        "href": "/components/radio#radiogruppe"
      }}>{`RadioGruppe`}</a>{`- og `}<a parentName="p" {...{
        "href": "/components/checkbox#checkboxgruppe"
      }}>{`CheckboxGruppe`}</a>{`-komponenter for at disse skal bli stylet slik at avstanden mellom elementene blir litt mindre og for at `}<inlineCode parentName="p">{`legend`}</inlineCode>{` skal bli seende ut som en vanlig `}<inlineCode parentName="p">{`label`}</inlineCode>{`:`}</p>
    <h3 {...{
      "id": "radiogruppe"
    }}>{`RadioGruppe`}</h3>
    <Example mdxType="Example">
  <RadioGruppe legend="Hvor vil du sitte?" mdxType="RadioGruppe">
    <Radio label={"Bakerst"} name="sitteplass" mdxType="Radio" />
    <Radio label={"Midten"} name="sitteplass" mdxType="Radio" />
    <Radio label={"Fremst"} name="sitteplass" mdxType="Radio" />
  </RadioGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<RadioGruppe legend="Hvor vil du sitte?">
  <Radio label={"Bakerst"} name="sitteplass" />
  <Radio label={"Midten"} name="sitteplass" />
  <Radio label={"Fremst"} name="sitteplass" />
</RadioGruppe>
`}</code></pre>
    <h3 {...{
      "id": "checkboxgruppe"
    }}>{`CheckboxGruppe`}</h3>
    <Example mdxType="Example">
  <CheckboxGruppe legend="Hvor vil du sitte?" mdxType="CheckboxGruppe">
    <Checkbox label={"Bakerst"} mdxType="Checkbox" />
    <Checkbox label={"Midten"} mdxType="Checkbox" />
    <Checkbox label={"Fremst"} mdxType="Checkbox" />
  </CheckboxGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<CheckboxGruppe legend="Hvor vil du sitte?">
  <Checkbox label={"Bakerst"} />
  <Checkbox label={"Midten"} />
  <Checkbox label={"Fremst"} />
</CheckboxGruppe>
`}</code></pre>
    <h2 {...{
      "id": "felles-feilmelding"
    }}>{`Felles feilmelding`}</h2>
    <Example mdxType="Example">
  <SkjemaGruppe feil="Her er det noe feil" mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" mdxType="Input" />
    <TextareaControlled label="Textarea-label" mdxType="TextareaControlled" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe feil="Her er det noe feil">
  <Input label="Fornavn" />
  <Input label="Etternavn" />
  <TextareaControlled label="Textarea-label" />
</SkjemaGruppe>
`}</code></pre>
    <h3 {...{
      "id": "uten-propagering-av-feil-prop-til-children"
    }}>{`Uten propagering av feil-prop til children`}</h3>
    <p>{`Bruk `}<inlineCode parentName="p">{`utenFeilPropagering`}</inlineCode>{`-propen for å bestemme om `}<inlineCode parentName="p">{`feil`}</inlineCode>{`-propen til `}<inlineCode parentName="p">{`SkjemaGruppe`}</inlineCode>{` skal propageres til children.`}</p>
    <Example mdxType="Example">
  <SkjemaGruppe feil="Her er det noe feil" utenFeilPropagering mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" feil="Feilen er her!" mdxType="Input" />
    <Input label="Adresse" mdxType="Input" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe feil="Her er det noe feil" utenFeilPropagering>
  <Input label="Fornavn" />
  <Input label="Etternavn" feil="Feilen er her!" />
  <Input label="Adresse" />
</SkjemaGruppe>
`}</code></pre>
    <h2 {...{
      "id": "custom-element"
    }}>{`Custom element`}</h2>
    <p>{`Du kan også selv bestemme hvilket HTML-element som SkjemaGruppe skal rendres som. Default er som nevnt `}<inlineCode parentName="p">{`fieldset`}</inlineCode>{`, men du kan overstyre dette via `}<inlineCode parentName="p">{`tag`}</inlineCode>{`-propen:`}</p>
    <Example mdxType="Example">
  <SkjemaGruppe tag="div" mdxType="SkjemaGruppe">
    <Input label="Fornavn" mdxType="Input" />
    <Input label="Etternavn" mdxType="Input" />
  </SkjemaGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<SkjemaGruppe tag="div">
  <Input label="Fornavn" />
  <Input label="Etternavn" />
</SkjemaGruppe>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      